export default class ModuleFourService {
  /**
   * @param {Number} calculationBasis
   * @param {Object} moduleFour 
   */
  static getAmountOfModuleFour(calculationBasis, moduleFour){
    return this.getAmountOfModuleFourOne(calculationBasis, moduleFour) +
        this.getAmountOfModuleFourTwo(calculationBasis, moduleFour)
  }

  /**
   * @param {Number} calculationBasis
   * @param {Object} moduleFour 
   */
  static getAmountOfModuleFourOne(calculationBasis, moduleFour){
    let percent = this.getAmountOfModuleFourOnePercents(moduleFour)
    return calculationBasis * percent / 100
  }
  /** 
   * @param {Object} moduleFour 
   */
  static getAmountOfModuleFourOnePercents(moduleFour){
    return  moduleFour.vacation +
        moduleFour.legalAbsences +
        moduleFour.paternityLicence +
        moduleFour.workAccident +
        moduleFour.maternityLicence +
        moduleFour.professionalAbsent +
        this.getOthersPercent(moduleFour.others)
  }
  /** 
   * @param {Object} moduleFour 
   */
  static getAmountOfModuleFourTwo(calculationBasis, moduleFour){
    return  calculationBasis * moduleFour.restAndFeeding / 100
  }
  static getOthersPercent(others){
    if(!others)
      return 0
    let amount = 0
    for (let i = 0; i < others.length; i++) {
      amount += others[i].percent;
    }
    return amount
  }
} // class



// WEBPACK FOOTER //
// ./src/service/ModuleFourService.js